import { render } from "./Article.vue?vue&type=template&id=431121ef&scoped=true"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"

import "./Article.vue?vue&type=style&index=0&id=431121ef&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-431121ef"

export default script